import './home.css'

import { Footer, Header, MediaBox, MediaBoxRow, PageHeader } from '../../Components';
import React, { useEffect, useState } from 'react';
import { authHeader, handleResponse } from '../../Helpers';

import EnglishResourceBundle from './locale/home.en.json';
import FrenchResourceBundle from './locale/home.fr.json';
import moment from 'moment'
import { useTranslation } from 'react-i18next';

export const Home = () => {
    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'home', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'home', FrenchResourceBundle);

    const [state, setState] = useState({
        formsToComplete: [],
        formsNotified: [],
        notifications: [],
        clients: [],
        templates: []
    });

    useEffect(() => {
        if (!i18n.language)
            return;

        const request = {
            method: "GET",
            headers: authHeader()
        }

        fetch(`${process.env.REACT_APP_APIURL}/api/home?culture=${i18n.language.substring(0, 2)}`, request)
            .then(handleResponse)
            .then(json => {  
                setState({
                    formsToComplete: json.forms.filter(p => p.status < 3 && p.isRecipient),
                    formsNotified: json.forms.filter(p => p.status >= 3 && p.isRecipient),
                    notifications: json.forms.filter(p => p.status >= 3 && p.isSender),
                    clients: json.clients,
                    templates: json.templates
                });
            });
    }, [i18n.language]);

    const getFormData = form => {
        const getLocalize = (localizations, name) => {
            let localize = localizations.find(p => p.culture === culture) ?? localizations[0];

            if (!localize[name])
                localize = localizations[0];

            return localize ? localize[name] : "";
        }

        const culture = i18n.language.substring(0, 2);
        const templates = state.templates.filter(p => p.id === form.templateId);
        const clients = state.clients.filter(p => p.id === form.clientId);
        
        moment.locale(i18n.language.substring(0,2));

        let description = [ getLocalize(clients, "name"), `version ${form.version}`, moment.utc(form.modificationDate).fromNow(), form.number ];

        return {
            title: getLocalize(templates, "name"),
            description: description,
            href: `/${getLocalize(clients, "key")}/${form.recipientEmail}/forms/${getLocalize(templates, "key")}/${form.number}${form.privateKey && form.privateKey.length > 0 ? `/${form.privateKey}` : ""}`.toLowerCase(),
            imageSrc: getLocalize(clients, "logo")
        }
    }

    return (
        <div className="container-fluid">
            <Header />                                 
        
            <div className="container">
                <PageHeader 
                    title={t("home:pageTitle")}
                    description={t("home:pageDescription")}>                
                </PageHeader>

                <br></br>            
                
                <MediaBox 
                    title={t("home:formsToCompleteTitle")}
                    description={t("home:formsToCompleteDescription")}
                    emptyText={t("home:formsToCompleteEmpty")}>   
                    { state.formsToComplete.length > 0 && state.formsToComplete.map(form => {
                        const formData = getFormData(form);
                        return (<MediaBoxRow key={form.id} title={formData.title} description={formData.description} href={formData.href} imageSrc={formData.imageSrc}></MediaBoxRow>);
                    }) }                
                </MediaBox>

                { state.formsNotified.length > 0 && 
                    <>
                        <br></br>

                        <MediaBox 
                            title={t("home:formsNotifiedTitle")}
                            description={t("home:formsNotifiedDescription")}
                            emptyText={t("home:formsNotifiedEmpty")}>                                    
                            { state.formsNotified.map(form => {
                                const formData = getFormData(form);
                                return (<MediaBoxRow key={form.id} title={formData.title} description={formData.description} href={formData.href}  imageSrc={formData.imageSrc}></MediaBoxRow>);
                            }) }                
                        </MediaBox>
                    </>
                }

                { state.notifications.length > 0 && 
                    <>
                        <br></br>
                
                        <MediaBox 
                            title={t("home:notificationReceivedTitle")}
                            description={t("home:notificationReceivedDescription")}
                            emptyText={t("home:notificationReceivedEmpty")}>  
                            { state.notifications.map(form => {
                                const formData = getFormData(form);
                                return (<MediaBoxRow key={form.id} title={formData.title} description={formData.description} href={formData.href}  imageSrc={formData.imageSrc}></MediaBoxRow>);
                            }) }                
                        </MediaBox>            
                    </>
                }                    
            </div>

            <Footer />
        </div>
    );
}